import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import UserContext from '../../context/UserContext';
import Login from '../authentication/Login';
import DeniedAccess from '../route/DeniedAccess';
import config from '../../config/config';

function PrivateRoute({ component: Component }) {
  const user = useContext(UserContext);
  const location = useLocation();
  
  const pathname = location.pathname;

  if(user.authenticated) {
    const routeAccess = config.routeAccess[pathname];

    if(!routeAccess && user.data.access === config.accessRoles.ADMIN) {
      // only allowed to admins by default
      return <Component />;
    }

    if(routeAccess && routeAccess.includes(user.data.access)) {
      // they are permitted this access
      return <Component />;
    }  

    return <DeniedAccess />
  }

  // not authenticated
  return <Login />;
}

export default PrivateRoute; 